import PerfectScrollbar from "perfect-scrollbar";
import {Block, Loading, Notify} from "notiflix";
import intlTelInput from "intl-tel-input";
import * as Sentry from "@sentry/browser";
import Lenis from "lenis";
import AOS from "aos";
import "fslightbox";


// @ts-ignore: lib has no definition
import Typify from 'typify.js';

export const PREVENT_CLASSES = [
    'select2-results__options',
    'custom__scrollbar',
    'overflow-y-scroll',
    'overflow-y-auto',
    'select2-results',
    'overflow-auto',
    'scrollbable',
    'sub-menu',
    'overflow',
    'pm__body',
    'map__col',
    'ps',
] as const;


const initLenis = () => {
    const lenis = new Lenis({
        duration: 2.5,
        smoothWheel: true,
        wheelMultiplier: 0.8,
        touchMultiplier: 1.5,
        lerp: 0.05,
        prevent: (node: Element): boolean => {
            return node.hasAttribute('data-init-scrollbar') || PREVENT_CLASSES.some(className => node.classList.contains(className))
        },
    })

    function raf(time: any) {
        lenis.raf(time)
        requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)
    window.AppScroll = lenis;
};

const initNotiflix = () => {

    Loading.init({
        backgroundColor: 'rgba(0,0,0,0.4)',
        fontFamily: 'Montserrat',
        svgColor: '#c7af7a',
        messageColor: '#000',
        svgSize: '80px',
    });

    Block.init({
        backgroundColor: 'rgba(0,0,0,0.4)',
        fontFamily: 'Montserrat',
        svgColor: '#c7af7a',
        messageColor: '#000',
        svgSize: '80px',
    });

    Notify.init({
        zindex: 9999999999, timeout: 5000, messageMaxLength: 500,
        clickToClose: true, closeButton: false, useFontAwesome: false, showOnlyTheLastOne: true, plainText: false,
        width: '450px', position: 'center-bottom', cssAnimationStyle: 'from-bottom', borderRadius: '8px', fontFamily: 'Montserrat',
        info: {background: '#c7af7a', textColor: '#FFF', notiflixIconColor: '#FFF'},
        warning: {background: '#23272b', textColor: '#FFF', notiflixIconColor: '#FFF'},
        failure: {notiflixIconColor: '#FFF'},
        success: {notiflixIconColor: '#FFF'},
    });
};

const initPhone = () => {

    const localStorageKeys = {
        time: '__lct__', //__lpct__ => last phone country timestamp;
        data: '__lcd__' //__lpcd__ => last phone country data
    }

    const getCachedData = () => {
        const __now = Date.now();
        const last__fetched = Math.floor((__now - (parseFloat(localStorage.getItem(localStorageKeys.time)) || 0)) / 60000);
        return last__fetched < 5 ? localStorage.getItem(localStorageKeys.data) : null
    }

    // noinspection JSUnusedGlobalSymbols
    const fr = {
        selectedCountryAriaLabel: "Pays sélectionné",
        noCountrySelected: "Aucun pays sélectionné",
        countryListAriaLabel: "Liste des pays",
        searchPlaceholder: "Rechercher...",
        clearSearchAriaLabel: "Effacer la recherche",
        searchEmptyState: "Aucun résultat trouvé",
        searchSummaryAria(count: number) {
            if (count === 0) return "Aucun résultat trouvé";
            if (count === 1) return "1 résultat trouvé";
            return `${count} résultats trouvés`;
        }
    };

    document.querySelectorAll<HTMLInputElement>('[data-init-phone]').forEach((input) => {
        // noinspection JSUnusedGlobalSymbols
        intlTelInput(input, {
            separateDialCode: true,
            containerClass: 'iti__custom_container',
            // dropdownContainer: getParent()[0],
            autoPlaceholder: 'aggressive',
            customPlaceholder: (selectedCountryPlaceholder) => "Ex : " + selectedCountryPlaceholder,
            initialCountry: "auto",
            strictMode: true,
            formatAsYouType: true,
            formatOnDisplay: true,
            useFullscreenPopup: false,
            i18n: {...fr, searchPlaceholder: "Rechercher ...",},
            geoIpLookup: async () => {
                const __ = getCachedData();
                if (__) return __;

                try {
                    const response = await fetch('https://api.country.is');
                    const data = await response.json();
                    const now = Date.now().toString();
                    const iso2 = data.country?.toLowerCase() ?? 'tg';

                    localStorage.setItem(localStorageKeys.data, iso2);
                    localStorage.setItem(localStorageKeys.time, now);

                    return iso2;
                } catch (e) {
                    console.warn("Country lookpup aborted: " + e)
                    localStorage.setItem(localStorageKeys.time, Date.now().toString());
                    localStorage.setItem(localStorageKeys.data, "tg")
                    return 'tg'
                }
            },
            loadUtils: () => import("intl-tel-input/dist/js/utils"),
        });

        input.addEventListener("open:countrydropdown", () => {
            setTimeout(() => {
                document.querySelectorAll('.iti__country-list').forEach((el) => {
                    el.classList.add('custom__scrollbar')
                })
            }, 200)
        });
    })
};

const initTypeAnimation = () => {
    const el = document.querySelector('[data-typify]')
    if (el) {
        // noinspection JSUnresolvedReference
        Typify('[data-typify]', {
            text: JSON.parse(el.getAttribute('data-typify')),
            delay: 100,
            loop: true,
            cursor: true,
            stringDelay: 1000
        });
    }
};

const initGallery = () => {
    document.querySelectorAll('[data-open-gallery]').forEach((el) => {
        el.addEventListener('click', () => {
            const data = JSON.parse(el.getAttribute('data-open-gallery'));
            if (!data) return;

            // @ts-ignore: library do not export type & ts types
            const lightbox = new FsLightbox();
            lightbox.props.sources = data;
            lightbox.open();
        })
    })
};

const initPlayer = () => {
    const playerZone = document.querySelector<HTMLElement>('.videos__items__container');
    const playerNode = document.getElementById('player__player')

    if (playerZone && playerNode) {

        const playlist: { [x: string]: any }[] = [];
        const itemsNode = document.querySelectorAll('.playlist__item');

        itemsNode.forEach((e) => {
            try {
                const data = JSON.parse(e.getAttribute('data-video'));
                playlist.push({
                    id: data.id,
                    file: data.file,
                    title: data.title,
                    poster: data.poster,
                    vars: {
                        colors: data.colors
                    }
                });
            } catch (e) {
                console.warn(e)
            }
        })

        // @ts-ignore: discoverable in vendors.js
        const player = new Playerjs({id: 'player__player', file: playlist});

        const __setSize = (h: string) => {
            playerZone.style.setProperty('--height', h);
        }

        playerNode.addEventListener("init", () => {
            __setSize(playerNode.style.height)
        });

        playerNode.addEventListener("height", () => {
            __setSize(playerNode.style.height)
        })

        playerNode.addEventListener("resize", () => {
            if (window.innerWidth <= 576) player.api('showplaylist');
            else player.api('showplaylist', 1);

            __setSize(playerNode.style.height)
        });

        itemsNode.forEach((e, i) => {
            e.addEventListener('click', () => {
                player.api('play', `id:${playlist[i].id}`)
            })
        })
    }
};

const initAos = (refresh: 'smooth' | 'hard' | null = null) => {
    if (refresh !== null) {
        refresh === 'smooth' ? AOS.refresh() : AOS.refreshHard();
        return;
    }

    AOS.init({
        duration: 800,
        once: false,
    });
};


const initPerfectScrollbar = () => {
    document.querySelectorAll<HTMLElement>('[data-init-scrollbar]').forEach((el) => {
        new PerfectScrollbar(el)
    })
}

const initSentry = () => {
    Sentry.init({
        dsn: "https://08545158d0167e5b75a386054b13e592@o4508474150551552.ingest.de.sentry.io/4511254568173648",
        sendDefaultPii: true,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        enableLogs: true,
        tracesSampleRate: 1.0,
        // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}


export const Plugins = {
    init: () => {
        initLenis();
        initNotiflix();
        initPhone();
        initTypeAnimation();
        initGallery();
        initPlayer();
        initAos();
        initPerfectScrollbar();
    },

    initLenis,
    initNotiflix,
    initPhone,
    initTypeAnimation,
    initGallery,
    initPlayer,
    initAos,
    initSentry,
}

export default Plugins;